import fcnEventsService from "@/services/fcnEventsService";

export const events = {
  namespaced: true,
  state: {
    events: [],
    meta: {},
  },
  mutations: {
    SET_EVENTS(state, payload) {
      if (Array.isArray(payload)) {
        state.events = payload;
        state.meta = {};
      } else {
        state.events = payload.data || [];
        state.meta = payload.meta || {};
      }
    },
  },

  actions: {
    async getEvents({ commit }, data) {
      const response = await fcnEventsService.getEvents(data);
      commit("SET_EVENTS", response.data);
      return response;
    },
  },
};
